import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer } from 'src/app/classes/customer.class';
import { ApiService } from './api/api.service';

@Injectable({ providedIn: 'root' })
export class CustomerService {
    constructor(private apiService: ApiService) {}

    public getList(): Observable<Customer[]> {
        return this.apiService.getCallData$<Customer[]>('customers');
    }

    getSingle(id: number) {
        return this.apiService.getCallData$<Customer>(`customers/${id}`);
    }

    search(search = '', limit = 150, forDeclarations = false) {
        return this.apiService.getCallData$<Customer[]>('customers', {
            search,
            limit,
            ...(forDeclarations && { include_archived_projects: true, include_customers_without_area: true }),
        });
    }

    public getPaginatedList(
        page: number,
        pageSize: number,
        search: string,
        onlyWithWork: boolean
    ): Observable<{ customers: Customer[]; total: number }> {
        return this.apiService.getCallData$<{ customers: Customer[]; total: number }>('customers/paginated', {
            page,
            per_page: pageSize,
            search,
            only_with_work: onlyWithWork,
        });
    }

    public show(id: number): Observable<Customer> {
        return this.apiService.getCallData$<Customer>(`customers/${id}/management`);
    }

    public create(customer: Partial<Customer>): Observable<Customer> {
        return this.apiService.postCall$<Customer>('customers', customer).pipe(map(response => response.data));
    }

    public update(id: number, customer: Partial<Customer> & { user_ids?: number[] }): Observable<Customer> {
        return this.apiService.putCall$<Customer>(`customers/${id}`, customer).pipe(map(response => response.data));
    }

    public delete(id: number): Observable<object> {
        return this.apiService.deleteCall$<object>(`customers/${id}`);
    }
}
